/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CertificateEdgeItem } from './CertificateEdgeItem';
import {
    CertificateEdgeItemFromJSON,
    CertificateEdgeItemFromJSONTyped,
    CertificateEdgeItemToJSON,
} from './CertificateEdgeItem';

/**
 * Related campaign credential
 * @export
 * @interface CampaignEdgedCredentialDetailedDto
 */
export interface CampaignEdgedCredentialDetailedDto {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    said?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    type?: CampaignEdgedCredentialDetailedDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    status?: CampaignEdgedCredentialDetailedDtoStatusEnum;
    /**
     * Human-readable Identifier for Credential. Set by creator of the credential
     * @type {string}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    credentialAlias?: string;
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    issueeAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    issueeAlias?: string;
    /**
     * AID of issuer - who created that credential
     * @type {string}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    issuerAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    issuerAlias?: string;
    /**
     * When the credential was issued in format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    issuedAt?: string;
    /**
     * When the credential was revoked if it was revoked. Format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    revokedAt?: string;
    /**
     * Schema ID of the credential
     * @type {string}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    schemaId?: string;
    /**
     * 
     * @type {{ [key: string]: CertificateEdgeItem; }}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    certificateChainMap?: { [key: string]: CertificateEdgeItem; };
    /**
     * Phone numbers in TN and Campaign credentials
     * @type {object}
     * @memberof CampaignEdgedCredentialDetailedDto
     */
    phoneNumbers?: object;
}


/**
 * @export
 */
export const CampaignEdgedCredentialDetailedDtoTypeEnum = {
    Unknown: 'UNKNOWN',
    Dossier: 'DOSSIER',
    OrgIdentity: 'ORG_IDENTITY',
    Range: 'RANGE',
    Brand: 'BRAND',
    TnAlloc: 'TN_ALLOC',
    DelSig: 'DEL_SIG',
    Qvi: 'QVI',
    Root: 'ROOT',
    A2PCampaign: 'A2P_CAMPAIGN'
} as const;
export type CampaignEdgedCredentialDetailedDtoTypeEnum = typeof CampaignEdgedCredentialDetailedDtoTypeEnum[keyof typeof CampaignEdgedCredentialDetailedDtoTypeEnum];

/**
 * @export
 */
export const CampaignEdgedCredentialDetailedDtoStatusEnum = {
    Active: 'ACTIVE',
    Expired: 'EXPIRED',
    Revoked: 'REVOKED'
} as const;
export type CampaignEdgedCredentialDetailedDtoStatusEnum = typeof CampaignEdgedCredentialDetailedDtoStatusEnum[keyof typeof CampaignEdgedCredentialDetailedDtoStatusEnum];


/**
 * Check if a given object implements the CampaignEdgedCredentialDetailedDto interface.
 */
export function instanceOfCampaignEdgedCredentialDetailedDto(value: object): boolean {
    return true;
}

export function CampaignEdgedCredentialDetailedDtoFromJSON(json: any): CampaignEdgedCredentialDetailedDto {
    return CampaignEdgedCredentialDetailedDtoFromJSONTyped(json, false);
}

export function CampaignEdgedCredentialDetailedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampaignEdgedCredentialDetailedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'] == null ? undefined : json['said'],
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
        'credentialAlias': json['credentialAlias'] == null ? undefined : json['credentialAlias'],
        'issueeAid': json['issueeAid'] == null ? undefined : json['issueeAid'],
        'issueeAlias': json['issueeAlias'] == null ? undefined : json['issueeAlias'],
        'issuerAid': json['issuerAid'] == null ? undefined : json['issuerAid'],
        'issuerAlias': json['issuerAlias'] == null ? undefined : json['issuerAlias'],
        'issuedAt': json['issuedAt'] == null ? undefined : json['issuedAt'],
        'revokedAt': json['revokedAt'] == null ? undefined : json['revokedAt'],
        'schemaId': json['schemaId'] == null ? undefined : json['schemaId'],
        'certificateChainMap': json['certificateChainMap'] == null ? undefined : (mapValues(json['certificateChainMap'], CertificateEdgeItemFromJSON)),
        'phoneNumbers': json['phoneNumbers'] == null ? undefined : json['phoneNumbers'],
    };
}

export function CampaignEdgedCredentialDetailedDtoToJSON(value?: CampaignEdgedCredentialDetailedDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'type': value['type'],
        'status': value['status'],
        'credentialAlias': value['credentialAlias'],
        'issueeAid': value['issueeAid'],
        'issueeAlias': value['issueeAlias'],
        'issuerAid': value['issuerAid'],
        'issuerAlias': value['issuerAlias'],
        'issuedAt': value['issuedAt'],
        'revokedAt': value['revokedAt'],
        'schemaId': value['schemaId'],
        'certificateChainMap': value['certificateChainMap'] == null ? undefined : (mapValues(value['certificateChainMap'], CertificateEdgeItemToJSON)),
        'phoneNumbers': value['phoneNumbers'],
    };
}

